export const coreWakeReconnectQueryOptions = {
  refetchOnReconnect: true,
  refetchOnWindowFocus: true,
} as const;
